module.exports = __webpack_public_path__ + "img/10.34884563.png";